import React from 'react';

const InputField = ({ placeholder, disabled, className ,type,name,value,onChange,style }) => {
    return (
        <div className={`w-[360px] m-0 p-0 ${className}`}>
            <div className="relative text-[14px] inline-block w-full">
                <input
                    name = {name}
                    value={value}
                    type = {type ? type : 'text'}
                    disabled={disabled}
                    autoComplete="off"
                    placeholder={placeholder}
                    className={`w-full bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] ${className} focus-within:ring-1 focus-within:ring-blue-500`}
                    onChange={onChange}
                    style={style}
                />
            </div>
        </div>
    );
};

export default InputField;